const momentFormat = {
  DATE: 'ddd, MMM D YYYY',
  DATE_TIME: 'ddd, MMM D YYYY [at] HH:mm',
  API: 'YYYY-MM-DD[T]HH:mm:ss',
};

const message = {
  CONTENT_WARNING: 'Your company will still be charged if booking is not Approved',
  NO_POLICY_BREAK: 'Within Policy',
  INSTANT_TICKET_FARE_TOOL_TIP_HEADER: 'Instant Ticket',
  INSTANT_TICKET_FARE_TOOL_TIP_DESCRIPTION: 'You will be immediately charged on confirming your booking.',
};

const api = {
  root: `${window.apiUrl}`,
  url: `${window.apiUrl}api/`,
  sctApiUrl: `${window.sctApiUrl}api/`,
  itinerary: `${window.apiUrl}api/Itinerary/`,
  iataGrouped: `${window.apiUrl}api/Itinerary/IataSearchGrouped`,
  iata: `${window.apiUrl}api/Itinerary/IataSearch`,
  iataSct: `${window.apiUrl}api/Itinerary/IataSearchSct`,
  citySearch: `${window.apiUrl}api/Location/city`,
  depotSearch: `${window.apiUrl}api/Car/depots`,
  travellers: `${window.apiUrl}api/Itinerary/Travellers`,
  itineraryMessaging: `${window.apiUrl}api/ItineraryMessaging`,
  car: `${window.apiUrl}api/car/results`,
  carDetails: `${window.apiUrl}api/car/detail`,
  carLocation: `${window.apiUrl}api/Car/Location`,
  hotels: `${window.apiUrl}api/hotel`,
  hotelPage: `${window.apiUrl}api/hotelPage`,
  hotelPartial: `${window.apiUrl}api/HotelPartial`,
  hotelRates: `${window.apiUrl}api/hotel/rates`,
  hotelCancellationInfo: `${window.apiUrl}api/hotel/CancellationInfo`,
  hotelReviews: `${window.apiUrl}api/hotel/reviews`,
  hotelPolicy: `${window.apiUrl}api/Hotel/CheckPolicy`,
  token: `${window.apiUrl}Token`,
  loyaltyPrograms: `${window.apiUrl}api/Itinerary/loyaltyprograms`,
  flail: `${window.apiUrl}api/Rail/`,
  supplierLocations: `${window.apiUrl}api/supplierLocations/`,
  poi: `${window.apiUrl}api/PointOfInterest`,
  flight: `${window.apiUrl}api/flight`,
  emailShareFlightOptions: `${window.apiUrl}api/flight/ShareFlightOptions`,
  carbonEmissions: `${window.apiUrl}api/CarbonEmissions`,
  companyReferences: `${window.apiUrl}api/Itinerary/companyreferences`,
  impersonateUser: `${window.apiUrl}api/ImpersonateUser`,
  version: 14,
  sctVersion: 1,
};

const API = {
  userActivity: {
    url: (slugs) => {
      return `${window.sctApiUrl}api/v${api.sctVersion}/debtors/${slugs.debtorId}/activity`;
    },
    mockUrl: () => {
      return `${window.SCT_MOCK_DATA_URL}/userActivity`;
    },
    useMockUrl: false,
  },
  userPeople: {
    url: (slugs) => {
      return slugs.id
        ? `${window.sctApiUrl}api/v${api.sctVersion}/debtors/${slugs.debtorId}/travellers/${slugs.id}`
        : `${window.sctApiUrl}api/v${api.sctVersion}/debtors/${slugs.debtorId}/travellers`;
    },
    mockUrl: (slugs) => {
      return slugs ? `${window.SCT_MOCK_DATA_URL}/userPeople/${slugs.id}` : `${window.SCT_MOCK_DATA_URL}/userPeople`;
    },
    useMockUrl: false,
  },
  userProfile: {
    url: `${window.sctApiUrl}api/v${api.sctVersion}/profile`,
    mockUrl: `${window.SCT_MOCK_DATA_URL}/userProfile`,
    useMockUrl: false,
  },
  userDebtor: {
    url: (slugs) => {
      return `${window.sctApiUrl}api/v${api.sctVersion}/debtors/${slugs.debtorId}`;
    },
    mockUrl: `${window.SCT_MOCK_DATA_URL}/userDebtor`,
    useMockUrl: false,
  },
  fareForecaster: {
    url: `${window.apiUrl}api/fareforecaster`,
    mockUrl: `${window.TRAVEL_MOCK_DATA_URL}/fareforecaster`,
    useMockUrl: false,
  },
  itinerary: {
    url: (slugs) => {
      return slugs ? `${window.apiUrl}api/Itinerary/${slugs.itineraryId}` : `${window.apiUrl}api/Itinerary`;
    },
    mockUrl: `${window.TRAVEL_MOCK_DATA_URL}/Itinerary`,
    useMockUrl: false,
  },
  costCentres: {
    url: `${window.apiUrl}api/CostCentres`,
    mockUrl: `${window.MOCK_DATA_URL}/CostCentres`,
    useMockUrl: false,
  },
  department: {
    url: `${window.apiUrl}api/Department`,
    mockUrl: `${window.MOCK_DATA_URL}/departments`,
    useMockUrl: false,
  },
  departmentCode: {
    url: `${window.apiUrl}api/Department/departmentCode`,
    mockUrl: `${window.MOCK_DATA_URL}/departmentCode`,
    useMockUrl: false,
  },
  settings: {
    url: `${window.apiUrl}api/Setting`,
    mockUrl: `${window.TRAVEL_MOCK_DATA_URL}/Settings`,
    useMockUrl: false,
  },
  travel: {
    url: `${window.apiUrl}api/travel/search/results`,
    mockUrl: `${window.TRAVEL_MOCK_DATA_URL}/Results`,
    useMockUrl: false,
  },
  travelDetail: {
    url: (slugs) => {
      return `${window.apiUrl}api/Travel/${slugs.travelId}/${slugs.type}/details`;
    },
    mockUrl: `${window.TRAVEL_MOCK_DATA_URL}/TravelDetail`,
    useMockUrl: false,
  },
  travelFareRules: {
    url: (slugs) => {
      return `${window.apiUrl}api/Travel/${slugs.travelId}/${slugs.type}/fareclasses/${slugs.fareId}/farerules`;
    },
    mockUrl: `${window.TRAVEL_MOCK_DATA_URL}/FareRules`,
    useMockUrl: false,
  },
  travelSeatMap: {
    url: (slugs) => {
      return `${window.apiUrl}api/SeatMap/search`;
    },
    mockUrl: `${window.TRAVEL_MOCK_DATA_URL}/SeatMap`,
    useMockUrl: false,
  },
  locations: {
    url: (slugs) => {
      return `${window.apiUrl}api/location/poi`;
    },
    mockUrl: `${window.MOCK_DATA_URL}/location/poi`,
    useMockUrl: false,
  },
  userInvite: {
    url: (slugs) => {
      return `${window.sctApiUrl}api/v${api.sctVersion}/debtors/${slugs.debtorId}/invites`;
    },
    mockUrl: `${window.SCT_MOCK_DATA_URL}/userInvite`,
    useMockUrl: false,
  },
  userRegister: {
    url: (slugs) => {
      return `${window.sctApiUrl}api/v${api.sctVersion}/profile/register`;
    },
    mockUrl: `${window.SCT_MOCK_DATA_URL}/userInvite`,
    useMockUrl: false,
  },
  forgotPassword: {
    url: (slugs) => {
      return `${window.sctApiUrl}api/v${api.sctVersion}/resetpassword?email=${encodeURIComponent(slugs.email)}`;
    },
    mockUrl: `${window.SCT_MOCK_DATA_URL}/userInvite`,
    useMockUrl: false,
  },
  resetPassword: {
    url: (slugs) => {
      return `${window.sctApiUrl}api/v${api.sctVersion}/resetpassword/${slugs.token}`;
    },
    mockUrl: `${window.SCT_MOCK_DATA_URL}/userInvite`,
    useMockUrl: false,
  },
  completeInvite: {
    url: (slugs) => {
      return `${window.sctApiUrl}api/v${api.sctVersion}/debtors/${slugs.debtorId}/invites/${slugs.token}/complete`;
    },
    mockUrl: `${window.SCT_MOCK_DATA_URL}/userInvite`,
    useMockUrl: false,
  },
  userContact: {
    url: (slugs) => {
      return `${window.sctApiUrl}api/v${api.sctVersion}/support/getintouch?message=${encodeURIComponent(slugs.message)}`;
    },
    mockUrl: `${window.SCT_MOCK_DATA_URL}/userInvite`,
    useMockUrl: false,
  },
  shareItinerary: {
    url: (slugs) => {
      return `${window.apiUrl}api/ShareItinerary`;
    },
    mockUrl: `${window.SCT_MOCK_DATA_URL}/ShareItinerary`,
    useMockUrl: false,
  },
  companyreferences: {
    url: (slugs) => {
      return `${window.apiUrl}api/Itinerary/companyreferences`;
    },
    mockUrl: `${window.MOCK_DATA_URL}/Itinerary/companyreferences`,
    useMockUrl: false,
  },
};

const version = {
  number: window.lbVersion,
};

const analytics = {
  enabled: window.ANALYTICS_ENABLED,
  trackingCode: window.ANALYTICS_CODE,
};

const appInsights = {
  enabled: window.APPINSIGHTS_ENABLED,
  key: window.APPINSIGHTS_CODE,
};

const client = {
  id: window.CLIENT_ID,
  secret: window.CLIENT_SECRET,
};

const BING_API_CRED = 'AqkExqjquai0sfSevSrsEaOMOzaNLUqDL4xFwXBnjbRJYaLxM_gh2TlGV42cXl1R';

const MOCK_DATA = {
  active: window.MOCK_DATA,
  cars: `${window.MOCK_DATA_URL}/cars`,
  carDetails: `${window.MOCK_DATA_URL}/carDetails`,
  supplierLocations: `${window.MOCK_DATA_URL}/supplierLocations`,
  hotels: `${window.HOTEL_MOCK_DATA_URL}/hotels`,
  hotelsPartial: `${window.HOTEL_MOCK_DATA_URL}/hotelsPartial`,
  rail: `${window.MOCK_DATA_URL}/Rail`,
};

const MVC = window.MVC;
const DISABLE_SEATMAPS = window.DISABLE_SEATMAPS;
const HTML_INPUT_MAXLEN_LIMIT = 524288; // 524,288 part of the HTML spec

const limits = {
  remarks: {
    // LOBT-837 JLF: despite inline amount of 50 we still include a default
    // in case the way we retreive this value in the future changes
    maxCharLen: 50 || HTML_INPUT_MAXLEN_LIMIT,
  },
};

// TODO: Remove this feature flag once bundles are approved and released.
const bundles = {
  enabled: false,
  useMockData: false,
};

export default {
  analytics: analytics,
  appInsights: appInsights,
  version: version,
  bingAPICred: BING_API_CRED,
  momentFormat: momentFormat,
  message: message,
  APP_URL: window.APP_URL,
  api: api,
  API: API,
  client: client,
  limits: limits,
  bundles: bundles,
  MOCK_DATA: MOCK_DATA,
  MVC: MVC,
  DISABLE_SEATMAPS,
};



// WEBPACK FOOTER //
// ./src/config/appConfig.js